<template>
  <div>
    <div v-if="showVerification" class="id-verification">
      <div class="col-md-12 white paddingtop20 paddingbottom40 marginbottom20">
        <ProgressHeader step="uploadSelfie" />

        <div class="row text-center selfie-section marginbottom30">
          <p class="section-title">Finish by taking a selfie</p>
          <p class="section-desc">
            We’ll use this photo to verify your identity. Please copy the gesture shown in the photo below, with your
            hand raised next to your head.
          </p>

          <div class="section-body margintop40">
            <p class="section-desc">Example photo:</p>
            <div class="margintop10">
              <img src="/resources/img/example_selfie.png" alt="" width="177" height="240" class="mx-auto" />
            </div>

            <SelectImage @photoRead="onPhotoRead" />
          </div>
        </div>
      </div>

      <div class="col-md-12 white paddingtop20 paddingbottom40 marginbottom20">
        <div class="row text-center feature-section margintop30 marginbottom30">
          <p class="section-title">Why do we need a photo of you?</p>
          <p class="section-desc">
            As part of the age verification process for state law, we need to <br class="hidden-xs" />ensure the ID of
            every patient belongs to them.
          </p>

          <div class="feature-list margintop40">
            <div>
              <img src="/resources/img/icons/blue_lock.png" alt="Lock" width="90" height="79" />
              <p class="margintop20">All data is fully encrypted with 256-BIT SSL security</p>
            </div>

            <div>
              <img src="/resources/img/icons/blue_verify.png" alt="Verify" width="90" height="75" />
              <p class="margintop20">Only our licensed medical staff verify your ID</p>
            </div>

            <div>
              <img src="/resources/img/icons/blue_hidden.png" alt="Don't share" width="90" height="64" />
              <p class="margintop20">We promise never to share your personal data</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showConfirmation" class="id-selfie-confirmation" id="id_selfie_confirmation">
      <div class="col-md-12 white paddingtop20 paddingbottom40 marginbottom20">
        <ProgressHeader step="uploadSelfie" />

        <div class="row text-center selfie-confirm-section marginbottom30">
          <p class="section-title">Finish by taking a selfie</p>
          <p class="section-desc">
            We’ll use this photo to verify your identity. Please copy the gesture shown in the photo below, with your
            hand raised next to your head.
          </p>

          <div class="section-body">
            <div class="row">
              <div class="col-xs-12 col-md-6 text-center your-photo">
                <p class="section-desc">Your photo:</p>

                <div class="photo">
                  <img :src="imageSrc" id="id_image_photo" class="margintop20" />
                  <button @click="deletePhoto" class="btn btn-blue" id="id_photo_delete">Delete</button>
                </div>
              </div>

              <div class="col-xs-12 col-md-6 text-center example">
                <p class="section-desc hidden-xs">Example photos:</p>
                <p>Before finishing, make sure that...</p>

                <img
                  src="/resources/img/example_selfie.png"
                  alt="Driver License"
                  width="118"
                  height="160"
                  class="mx-auto"
                />

                <div class="tips">
                  <img src="/resources/img/green_check.png" alt="" width="16.5" height="16.5" />
                  <span>The photo isn’t too dark or blurry</span>
                </div>

                <div class="tips">
                  <img src="/resources/img/green_check.png" alt="" width="16.5" height="16.5" />
                  <span>Your hand is raised beside your head</span>
                </div>

                <div class="tips">
                  <img src="/resources/img/green_check.png" alt="" width="16.5" height="16.5" />
                  <span>Your face is clear and not covered</span>
                </div>
              </div>
            </div>

            <div class="margintop20">
              <upload-button @click="continueClick" :in-progress="inProgress"></upload-button>

              <div class="security">
                <img src="/resources/img/icons/grey_lock.png" alt="Driver License" width="12" height="15" />
                <p>256-BIT SSL SECURITY</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import UploadButton from "@/ComponentLibrary/UploadButton.vue";

import ProgressHeader from "./ProgressHeader.vue";
import SelectImage from "./SelectImage.vue";

export default Vue.extend({
  props: {
    imageSrc: {
      type: String,
      required: false,
    },
    showConfirmation: {
      type: Boolean,
      required: true,
    },
    showVerification: {
      type: Boolean,
      required: true,
    },
    inProgress: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    ProgressHeader,
    SelectImage,
    UploadButton,
  },
  methods: {
    onPhotoRead(blob: Blob) {
      this.$emit("photoRead", blob);
    },
    deletePhoto() {
      this.$emit("deletePhoto");
    },
    continueClick() {
      this.$emit("continueClick");
    },
  },
});
</script>
